import {Routes} from '@angular/router';
import {MDashboardComponent} from './views/dashboard/m-dashboard.component';
import {AuthGuardService as AuthGuard} from '../../auth-guard.service';
import {NgxPermissionsGuard} from 'ngx-permissions';
import {permissions} from '../../permissions';
import {MMasterDataComponent} from './views/master-data/m-master-data.component';
import {MTransactionsComponent} from './views/transactions/m-transactions.component';
import {MMasterDataViewComponent} from './views/master-data/master-data-view/m-master-data-view.component';
import {MScannedDataComponent} from './views/scanned-data/m-scanned-data.component';
import {MScannedDataViewComponent} from './views/scanned-data/scanned-data-view/m-scanned-data-view.component';
import {MTransactionViewComponent} from './views/transactions/transaction-view/m-transaction-view.component';
import {MQuickOrderComponent} from './views/quick-order/m-quick-order.component';

export const routes: Routes = [
    {
        path: 'mobile/dashboard',
        component: MDashboardComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'Dashboard',
            permissions: {
                only: [permissions.DASHBOARD_READ]
            }
        }
    },
    {
        path: 'mobile/oes/master-data',
        component: MMasterDataComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Master Data',
            permissions: {
                only: [permissions.OES_MASTER_DATA]
            }
        }
    },
    {
        path: 'mobile/oes/master-data/view/:id',
        component: MMasterDataViewComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Master Data View',
            permissions: {
                only: [permissions.OES_MASTER_DATA]
            }
        }
    },
    {
        path: 'mobile/oes/scanned-data',
        component: MScannedDataComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Scanned Data',
            permissions: {
                only: [permissions.OES_SCANNED_DATA]
            }
        }
    },
    {
        path: 'mobile/oes/scanned-data/view/:id',
        component: MScannedDataViewComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Scanned Data View',
            permissions: {
                only: [permissions.OES_VIEW_REPLENISHMENT_SCANS]
            }
        }
    },
    {
        path: 'mobile/oes/consumption-data',
        component: MScannedDataComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Consumption Data',
            permissions: {
                only: [permissions.OES_SCANNED_DATA]
            }
        }
    },
    {
        path: 'mobile/oes/consumption-data/view/:id',
        component: MScannedDataViewComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Consumption Data View',
            permissions: {
                only: [permissions.OES_SCANNED_DATA]
            }
        }
    },
    {
        path: 'mobile/oes/receiving-data',
        component: MScannedDataComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Receiving Data',
            permissions: {
                only: [permissions.OES_SCANNED_DATA]
            }
        }
    },
    {
        path: 'mobile/oes/receiving-data/view/:id',
        component: MScannedDataViewComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Receiving Data View',
            permissions: {
                only: [permissions.OES_SCANNED_DATA]
            }
        }
    },
    {
        path: 'mobile/transactions',
        component: MTransactionsComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'EDI - Transactions',
            permissions: {
                only: [permissions.TRANSACTIONS_READ]
            }
        }
    },
    {
        path: 'mobile/transactions/view/:id',
        component: MTransactionViewComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'EDI - Transaction View',
            permissions: {
                only: [permissions.TRANSACTIONS_READ]
            }
        }
    },
    {
        path: 'mobile/oes/replenishment-order',
        component: MQuickOrderComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Replenishment Order',
            permissions: {
                only: [permissions.OES_SAVED_DATA_READ]
            }
        }
    },
    {
        path: 'mobile/oes/consumption-order',
        component: MQuickOrderComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Consumption Order',
            permissions: {
                only: [permissions.OES_SAVED_DATA_READ]
            }
        }
    },
    {
        path: 'mobile/oes/receiving-order',
        component: MQuickOrderComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            title: 'OES - Receiving Order',
            permissions: {
                only: [permissions.OES_SAVED_DATA_READ]
            }
        }
    }
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/mobile.routing.ts